import React, { useState, useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import {
  MDBPagination,
  MDBPaginationItem,
  MDBPaginationLink
} from 'mdb-react-ui-kit';
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { get } from "../../../Services/RestAPIService";
import { Link, useNavigate } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import Dummy from "../../../assets/images/No_Image_Available.jpg";
import { useParams } from 'react-router-dom';

const VideosListing = ({ t }) => {
  const { subid, exeid ,id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({
    columns: [
      {
        label: t("ID"),
        field: "id",
        sort: "asc",
        width: 50,
      },
      {
        label: t("Title"),
        field: "title",
        sort: "asc",
        width: 150,
      },
    //   {
    //     label: t("Description"),
    //     field: "description",
    //     sort: "asc",
    //     width: 200,
    //   },
      {
        label: t("Activities"),
        field: "activities",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Frequency"),
        field: "frequency",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Occupation"),
        field: "occupation",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Standing"),
        field: "exercise_while_standing",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Lying Down"),
        field: "exercise_while_lying",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Video"),
        field: "video",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Edit"),
        field: "edit",
        sort: "asc",
        width: 100,
      },
    ],
    rows: []
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const fetchVideosData = async () => {
    try {
      // const response = await get(`exercise/exercises-videos/?exercises=${id}`);
      const response = await get(`exercise/exercises-videos/?exercises=${id}`);

      console.log(response,"response")
      const videoData = response.results;
      setTotalPages(response.total_pages);

      const formattedRows = videoData.map(video => ({
        id: video.id,
        title: video.title,
        description: video.description,
        activities: video?.activities?.join(", "),
        frequency: video.frequency,
        occupation: video?.occupation?.join(", "),
        exercise_while_standing: video.exercise_while_standing ? t('Yes') : t('No'),
        exercise_while_lying: video.exercise_while_lying ? t('Yes') : t('No'),
        video: <a href={video.video} target="_blank" rel="noopener noreferrer">{t("Watch Video")}</a>,
        edit: <Button color="secondary" onClick={() => handleEdit(video.id)}>{t("Edit")}</Button>
      }));

      setData(prevState => ({
        ...prevState,
        rows: formattedRows
      }));
      // console.log(formattedRows,response)
    } catch (error) {
      console.error('Error fetching video data:', error);
    }
  };

  useEffect(() => {
    fetchVideosData();
  }, [id]);

  const handleEdit = (videoId) => {
    navigate(`/category/edit-video/${subid}/${exeid}/${videoId}`);
  };

  const handleTableChange = (newPage) => {
    setCurrentPage(newPage);
    fetchVideosData(newPage);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle={t("Home")} title={t("Exercises")} titleLink={`/category/exercise/${subid}/${exeid}`} breadcrumbItem={t("Exercise Videos")} />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <CardTitle className="h4">{t("Exercise Videos")}</CardTitle>
                  <Button color="primary" onClick={() => navigate(`/category/add-video/${subid}/${exeid}/${id}`)}>
                    <i className="typcn typcn-plus"></i> {t("Add New Video")}
                  </Button>
                  </div>
                  

                  <MDBDataTable
                    responsive
                    striped
                    bordered
                    paging={false}
                    data={data}
                    className="custom-cursor-pointer"
                  />


                  
                  <MDBPagination className='mt-3'>
                    <MDBPaginationItem disabled={currentPage === 1}>
                      <MDBPaginationLink onClick={() => handleTableChange(currentPage - 1)} tabIndex="-1" aria-disabled={currentPage === 1}>
                        {t("Previous")}
                      </MDBPaginationLink>
                    </MDBPaginationItem>
                    {[...Array(totalPages).keys()].map(page => (
                      <MDBPaginationItem key={page + 1} active={currentPage === page + 1}>
                        <MDBPaginationLink onClick={() => handleTableChange(page + 1)}>
                          {page + 1}
                        </MDBPaginationLink>
                      </MDBPaginationItem>
                    ))}
                    <MDBPaginationItem disabled={currentPage === totalPages}>
                      <MDBPaginationLink onClick={() => handleTableChange(currentPage + 1)}>
                        {t("Next")}
                      </MDBPaginationLink>
                    </MDBPaginationItem>
                  </MDBPagination>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(VideosListing);
